import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/AgentMyAccount.css';
import SalespersonSidebar from "./SalespersonSidebar";

/* const agentAccount = {
    smwwMail:"",
    name:"TestKrishna Roja",
    personalMail:"Krishnaroja@gmail.com",
    publicProfile: "https://www.smwwagency.com/agent/testkrishna-rojatest",
} */

const AgentMyAccount = () => {

    const [isLoading, setIsLoading] = useState(true); 
    const [agentAccount, setAgentAccount] = useState({});

    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    var {uid} = useParams();
    const domainName = window.location.host.replace(/^https?:\/\//, '');

    useEffect(() => {
        Promise.all([
            getagentaccountdetails()
        ])
        .then(() => {
        
            setIsLoading(false);
        })
        
    },[]);
    async function getagentaccountdetails() {
    
       
            const response = await fetch(
                 app_url+'smwwagency/getagentaccountdetails?uid='+loggedin_uid,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setAgentAccount(responsedata.data.result);
            }
       
    }

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>My Account</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="page-view-myorder">
                            <div className="panel panel-default">
                                <div className="panel-heading" style={{background:"#fefefe"}}>
                                    <h1 style={{marginTop:"0px", marginBottom: "20px"}}>{agentAccount.name}</h1>
                                </div>
                            
                                <div className="panel-body agent-my-account-body">
                                    <p>Your SMWW mail alias is: <b>{agentAccount.smwwMail}</b></p>
                                    <p>This is the email address shown on the SMWWAgency.com site.</p>
                                    <p>Which directs mail to your personal email of: <b>{agentAccount.personalMail}</b></p>
                                    <p>The link to your public profile page is:</p>
                                    <p>
                                        <b><a href={agentAccount.publicProfile} target="_blank" style={{overflowWrap:"break-word"}}>{agentAccount.publicProfile}</a></b>
                                    </p>
                                    <p>To renew your membership,  <a href={agentAccount.cart_link} target="">click here</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        {/* <AgentBackendSidebar /> */}
                        <SalespersonSidebar />
                        {/* {!isReady ? (
                            <></>
                        ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                        <>
                            <AgentBackendSidebar />
                            <SalespersonSidebar />
                        </>
                        ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                        userLoggedInRoles.includes(configData.ROLE_AGENT)) ? (
                            <AgentBackendSidebar />
                        ) : (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                            <SalespersonSidebar />
                        ) : (
                            <div>
                                <h1>Quick Links</h1>
                                <ul style={{padding: "0px"}}>
                                    <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                                    <li>
                                    <a href="/smww_pay">
                                    <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                                    </a>
                                    </li>
                                </ul>
                            </div>
                        )} */}
                    </div>
                </div>
            )}
        </>
    );
};
export default AgentMyAccount;